import { useState } from "react";
import { submitLead } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Shared logic for the two lead-capture forms on the site
 * (Get-the-app modal + the Home Final CTA). Keeps validation,
 * status enum, and analytics dispatch in one place.
 */
export function useLeadForm({ source, placement }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const reset = () => {
    setEmail("");
    setStatus("idle");
    setErrorMsg("");
  };

  const submit = async (event) => {
    if (event?.preventDefault) event.preventDefault();
    if (status === "loading") return;

    const trimmed = email.trim();
    if (!trimmed || !EMAIL_RE.test(trimmed)) {
      setStatus("error");
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    setStatus("loading");
    setErrorMsg("");
    try {
      await submitLead({
        email: trimmed,
        source,
        page:
          typeof window !== "undefined" ? window.location.pathname : null,
      });
      trackEvent("lead_submit_success", { placement });
      setStatus("success");
    } catch (err) {
      const message =
        err?.response?.data?.detail ||
        "Something went wrong. Please try again.";
      setStatus("error");
      setErrorMsg(message);
      trackEvent("lead_submit_error", { placement, message });
    }
  };

  return {
    email,
    setEmail,
    status,
    errorMsg,
    submit,
    reset,
  };
}
